import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import {
  getEvaluation,
  submitEvaluation,
} from "../../services/portalAluno/evaluation/evaluationService";
import type {
  EvaluationAnswers,
  EvaluationData,
} from "../../@types/portalAluno";
import type { ApplicationState } from "../../store";

export const portalEvaluationQueryKey = (
  idUsuario?: number,
  idAvaliacao?: number
) => ["portal-aluno", "avaliacao", idUsuario, idAvaliacao];

const useEvaluation = (idAvaliacao?: number) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;
  const queryClient = useQueryClient();
  const query = useQuery({
    enabled: Boolean(idUsuario && idAvaliacao && idAvaliacao > 0),
    queryKey: portalEvaluationQueryKey(idUsuario, idAvaliacao),
    queryFn: () => getEvaluation(idAvaliacao as number),
  });
  const submitMutation = useMutation({
    mutationFn: ({
      answers,
      evaluation,
    }: {
      answers: EvaluationAnswers;
      evaluation: EvaluationData;
    }) => submitEvaluation(evaluation, answers),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["portal-aluno"] }),
  });

  return {
    ...query,
    isSubmitting: submitMutation.isLoading,
    submit: submitMutation.mutateAsync,
  };
};

export default useEvaluation;
